// features/clara-ai-chat/constants.ts

/**
 * Clara AI Chat Configuration Constants
 */

/** Check if running on localhost for development */
export const IS_LOCAL_DEV = typeof window !== 'undefined' && 
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

/** Default Clara AI Chat base URL - update based on environment */
export const CLARA_AI_CHAT_CONFIG = {
  /** Development environment URL */
  DEV_URL: 'https://kpmgclara.aichatdev.dev.kpmg.com',
  /** Production environment URL */
  PROD_URL: 'https://kpmgclara.aichat.kpmg.com',
  /** Integration ID for this consumer application (KCI) */
  INTEGRATION_ID: 'edf4a3af-f37f-4c51-9871-4212f1d250b1',
  /** Default theme ID (optional - configure in AI Platform admin center) */
  THEME_ID: undefined as string | undefined,
  /** Enable mock mode for local development (set to true to bypass iframe) */
  USE_MOCK_ON_LOCALHOST: true,
} as const;

/** Context sent whenever KCI Core mounts Clara in standalone mode. */
export function getStandaloneContext(selectedLanguage?: string): Array<{ key: string; value: string }> {
  const languageTag = selectedLanguage?.trim() ||
    (typeof navigator !== 'undefined' ? navigator.language : 'en-US');
  const [language = 'en', country = 'US'] = languageTag.split('-');
  const locale = `${language}-${country}`;
  const ctry = (typeof navigator !== 'undefined' ? navigator.language : '');

  return [
    { key: 'Language', value: locale },
    { key: 'ctry', value: ctry },
    { key: 'SCREEN.TYPE', value: 'Standalone' },
  ];
}

/** Trusted origins for postMessage validation */
export const TRUSTED_ORIGINS = [
  'https://kpmgclara1.aichat.dev.kpmg.com',
  'https://kpmgclara.aichat.dev.kpmg.com',
  'https://kpmgclara.aichat.kpmg.com',
  'https://kpmgclara.aichatdev.dev.kpmg.com'
] as const;

/** Default iframe permissions */
export const IFRAME_PERMISSIONS = 'clipboard-write *; microphone *';

/** Iframe element ID */
export const AI_CHAT_FRAME_ID = 'AIChatFrame';
